import { useEffect, useState } from 'react';
/*
The accordion is a wrapper for tracking the visibility of contents within a hidden/reveal panel setup.

Reveal sequence:
(in setChangeInternal)
- receive instruction for active = true
- call onStartReveal
- set active to true
(in effect for active change)
- call onChange
- if duration, start timer
- (after timer)
- call onEndReveal

Hide sequence:
(in setChangeInternal)
- receive instruction for active = false
- call onStartHide
- if duration, start timer
- (after timer)
- set active to false
(in effect for active change)
- call onChange
- call onEndHide

*/
export const useCFAccordion = (activeAtStart, options) => {
    const [active, setActive] = useState(activeAtStart);
    const toggle = () => {
        const newActive = !active;
        setChangeInternal(newActive);
        return newActive;
    };
    const setChangeInternal = (newActive) => {
        const { duration, durationOffset, onStartHide, onStartReveal } = options || {};
        // If changing to active begin reveal sequence (see above)
        if (newActive) {
            if (onStartReveal)
                onStartReveal();
            setActive(newActive);
        }
        // Otherwise start hide sequence (see above)
        else {
            if (onStartHide)
                onStartHide();
            if (duration) {
                setTimeout(() => {
                    setActive(newActive);
                }, duration + (durationOffset || 10));
            }
            else {
                setActive(newActive);
            }
        }
    };
    useEffect(() => {
        const { duration, durationOffset, onChange, onEndHide, onEndReveal } = options || {
            onChange: null,
        };
        if (onChange)
            onChange(active);
        // If active continue reveal sequence (see above)
        if (active) {
            if (duration) {
                setTimeout(() => {
                    if (onEndReveal)
                        onEndReveal();
                }, duration + (durationOffset || 10));
            }
            else {
                if (onEndReveal)
                    onEndReveal();
            }
        }
        // Otherwise continue hide sequence (see above)
        else {
            if (onEndHide)
                onEndHide();
        }
    }, [active]);
    return {
        active,
        setActive: setChangeInternal,
        toggle,
    };
};
